import { createI18n } from 'vue-i18n'
import en from './en.json'
import zh from './zh.json'
import id from './id.json'
import { bitable } from '@lark-base-open/js-sdk'

export const i18n = createI18n({
  locale: 'en',
  legacy: false,
  messages: {
    en,
    zh,
    id
  }
})

// Set locale from Lark context
bitable.bridge.getLanguage().then((lang) => {
  // Default to 'en' if language not supported
  if (lang === 'zh' || lang === 'en' || lang === 'id') {
    i18n.global.locale.value = lang
  } else {
    i18n.global.locale.value = 'en'
  }
})
